interface OpenViewerArgs {
  rfqId?: string;
  chatRoomId?: string;
  selectedFileId?: string;
  annotation?: {
    id: string;
    commentId?: string;
  };
}

const openViewer = ({
  rfqId,
  chatRoomId,
  selectedFileId,
  annotation
}: OpenViewerArgs) => {
  const url = new URL(`${window.location.origin}/viewer`);

  url.searchParams.append('mode', chatRoomId ? 'chat' : 'default');

  if (rfqId) {
    url.searchParams.append('rfqId', rfqId);
  }

  if (chatRoomId) {
    url.searchParams.append('chatRoomId', chatRoomId);
  }

  if (selectedFileId) {
    url.searchParams.append('selectedFileId', selectedFileId);
  }

  if (annotation?.id) {
    url.searchParams.append('annotationId', annotation.id);
  }

  if (annotation?.commentId) {
    url.searchParams.append('commentId', annotation.commentId);
  }

  window.open(url.toString(), '_blank', 'popup');
};

export default openViewer;
